import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { putData } from "../../../utils/api";
import toast, { Toaster } from "react-hot-toast";
import { IDS } from "../../../utils/common";

const emptyForm = {
  min_amount: "",
  max_amount: "",
  charge: "",
  charge_type: "fixed",
};

// Shared by Facility Charges and Packing Charges (endpoint = "platform-charge" | "packing-charge")
const PlatformChargeRanges = ({
  endpoint = "platform-charge",
  title = "Facility Charges",
}) => {
  const { getData, postData, isAllow } = useContext(Context);
  const canEdit = isAllow?.includes(IDS.AppSetup.Edit);

  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);

  const getRows = async () => {
    const response = await getData(`/admin/setting/${endpoint}`);
    setRows(Array.isArray(response?.data) ? response.data : []);
  };

  useEffect(() => {
    resetForm();
    getRows();
  }, [endpoint]);

  const resetForm = () => {
    setForm(emptyForm);
    setEditId(null);
  };

  const handleSave = async () => {
    if (form.min_amount === "" || form.charge === "") {
      toast.error("From amount and charge are required");
      return;
    }
    const payload = {
      min_amount: form.min_amount,
      max_amount: form.max_amount,
      charge: form.charge,
      charge_type: form.charge_type,
    };
    const response = editId
      ? await putData(`/admin/setting/${endpoint}/${editId}`, payload)
      : await postData(`/admin/setting/${endpoint}`, payload);

    if (response?.success) {
      toast.success(response?.data || "Saved");
      resetForm();
      getRows();
    } else {
      toast.error(
        (typeof response?.errors === "string" && response.errors) ||
          response?.message ||
          "Something went wrong",
      );
    }
  };

  const handleEdit = (row) => {
    setEditId(row.id);
    setForm({
      min_amount: row.min_amount,
      max_amount: row.max_amount ?? "",
      charge: row.charge,
      charge_type: row.charge_type || "fixed",
    });
  };

  const setField = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={title}
          link={`/admin/setting/${endpoint}`}
        />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels mt-3">
                {canEdit && (
                  <div className="row g-2 align-items-end mb-3">
                    <div className="col-md-2">
                      <label className="form-label">From (₹)</label>
                      <input
                        type="number"
                        min={0}
                        className="form-control"
                        value={form.min_amount}
                        onChange={setField("min_amount")}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        To (₹) - empty for no limit
                      </label>
                      <input
                        type="number"
                        min={0}
                        className="form-control"
                        value={form.max_amount}
                        onChange={setField("max_amount")}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Type</label>
                      <select
                        className="form-select"
                        value={form.charge_type}
                        onChange={setField("charge_type")}
                      >
                        <option value="fixed">Fixed (₹)</option>
                        <option value="percentage">% of order</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Charge</label>
                      <input
                        type="number"
                        min={0}
                        className="form-control"
                        value={form.charge}
                        onChange={setField("charge")}
                      />
                    </div>
                    <div className="col-md-3 d-flex gap-2">
                      <button className="btn btn-primary" onClick={handleSave}>
                        {editId ? "Update" : "Add"}
                      </button>
                      {editId && (
                        <button
                          className="btn btn-secondary"
                          onClick={resetForm}
                        >
                          Cancel
                        </button>
                      )}
                    </div>
                  </div>
                )}

                <Table bordered responsive hover>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>From (₹)</th>
                      <th>To (₹)</th>
                      <th>{title.replace(/s$/, "")}</th>
                      {canEdit && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length ? (
                      rows.map((row, i) => (
                        <tr key={row.id}>
                          <td>{i + 1}</td>
                          <td>{row.min_amount}</td>
                          <td>{row.max_amount ?? "No limit"}</td>
                          <td>
                            {row.charge_type === "percentage"
                              ? `${row.charge}% of order value`
                              : `₹ ${row.charge}`}
                          </td>
                          {canEdit && (
                            <td>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleEdit(row)}
                                >
                                  Edit
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={canEdit ? 5 : 4} className="text-center">
                          No ranges added
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </section>
            </div>
          </div>
        </section>
      </div>
      <Toaster position="top-right" />
    </>
  );
};

export default PlatformChargeRanges;
